import type { EmpleadoResumen } from '@/lib/ventas/types';
import { rolEtiqueta } from '@/lib/ventas/periodo';

interface Props {
  empleados: EmpleadoResumen[];
  periodoLabel: string;
}

export default function ResumenEmpleados({ empleados, periodoLabel }: Props) {
  return (
    <div className="bg-white rounded-xl border border-background-200 p-5">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-accent-100 text-accent-600 flex items-center justify-center">
            <i className="ri-team-line"></i>
          </div>
          <h3 className="font-heading text-base font-semibold text-foreground-800">Ventas por Empleado</h3>
        </div>
        <span className="text-xs text-foreground-400 whitespace-nowrap">{periodoLabel}</span>
      </div>

      {empleados.length === 0 ? (
        <p className="text-sm text-foreground-400 text-center py-8">Sin ventas en el período seleccionado</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3">
          {empleados.map((e) => (
            <div key={e.key} className="rounded-lg border border-background-200 bg-background-50 p-4">
              <div className="flex items-start justify-between gap-2 mb-3">
                <div className="flex items-center gap-2 min-w-0">
                  <div className="w-9 h-9 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center flex-shrink-0 font-semibold text-sm">
                    {e.nombre.charAt(0).toUpperCase()}
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-foreground-800 truncate">{e.nombre}</p>
                    <p className="text-xs text-foreground-400 truncate">@{e.usuario}</p>
                  </div>
                </div>
                <span
                  className={`px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${
                    e.rol === 'super_admin' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-800'
                  }`}
                >
                  {rolEtiqueta(e.rol)}
                </span>
              </div>
              <div className="flex items-end justify-between">
                <div>
                  <p className="text-xs text-foreground-400">Ventas</p>
                  <p className="text-sm font-semibold text-foreground-700">{e.cantidad}</p>
                </div>
                <div className="text-right">
                  <p className="text-xs text-foreground-400">Total</p>
                  <p className="text-sm font-bold text-primary-600">Bs. {e.total.toFixed(2)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}